(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6323],{

/***/ 25704:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/thresholds",
      function () {
        return __webpack_require__(15147);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const FeatureRow = (param)=>{
    let { title , description , icon , align ="left" , last =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `flex flex-col items-center pb-10 mb-10 sm:flex-row xl:px-20 ${last ? "border-b-0" : "border-b border-gray-200"}`,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `inline-flex items-center justify-center flex-shrink-0 w-20 h-20 text-summer-green-700 bg-summer-green-100 border border-summer-green-300 rounded-full sm:w-28 sm:h-28 sm:mr-10 mb-6 sm:mb-0 ${align === "right" ? "sm:hidden" : ""}`,
                children: icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `flex-grow text-center sm:text-left`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "mb-2 text-lg font-medium text-san-juan-blue-500 title-font",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-base leading-relaxed",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `inline-flex items-center justify-center flex-shrink-0 w-20 h-20 text-summer-green-700 bg-summer-green-100 border border-summer-green-300 rounded-full sm:w-28 sm:h-28 sm:ml-10 ${align === "right" ? "hidden sm:inline-flex" : "hidden"}`,
                children: icon
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeatureRow);


/***/ }),

/***/ 15147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_home_SEO__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56925);
/* harmony import */ var components_home_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90166);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8193);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5434);
/* harmony import */ var react_icons_tb__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37106);
/* harmony import */ var components_home_CtaSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38341);
/* harmony import */ var components_home_FeatureSection_FeatureRow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70426);








const features = [
    {
        title: "Pass/Fail Conditions",
        description: "Define thresholds to pass/fail your performance tests. Thresholds automatically apply to all test runs in a test scenario. Conditions can be set for response time, error counts, request counts, and more.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_5__/* .AiOutlineCheckCircle */ .KP3, {
            className: "w-8 h-8 sm:w-14 sm:h-14"
        })
    },
    {
        title: "Automated Testing",
        description: "Use status checks in your test automation pipelines to determine performance health. Integrate with your CI/CD tool of choice to automatically run performance tests, report results, and pause deployments.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_tb__WEBPACK_IMPORTED_MODULE_6__/* .TbTestPipe2 */ .fhe, {
            className: "w-8 h-8 sm:w-14 sm:h-14"
        })
    },
    {
        title: "Performance Benchmarks",
        description: "Catch performance regressions before they impact your users. Build trust and clarity in your performance monitoring as a team.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_7__/* .MdOutlineHealthAndSafety */ .T2A, {
            className: "w-8 h-8 sm:w-14 sm:h-14"
        }),
        last: true
    }
];
const ThresholdsPage = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_home_SEO__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                title: "Thresholds"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_home_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "text-gray-700 body-font bg-gray-50",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "container flex flex-col items-center px-5 pt-12 pb-6 mx-auto md:flex-row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col items-center text-center mb-6 md:mb-0 md:w-1/2 lg:pr-24 md:pr-16 md:items-start md:text-left",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "mb-4 text-3xl font-bold text-san-juan-blue-500 title-font sm:text-4xl",
                                            children: "Thresholds to measure load test objectives"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mb-8 leading-relaxed",
                                            children: "Define pass/fail conditions for your performance tests and monitor their health. Integrate with your CI/CD pipeline to help determine build status."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex justify-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "https://docs.latencylingo.com/docs/getting-started",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                    className: "px-8 py-4 text-lg font-medium text-summer-green-700 bg-summer-green-100 shadow border border-summer-green-300 rounded focus:outline-none hover:bg-summer-green-200",
                                                    children: "Learn more"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-5/6 mb-10 md:w-1/2 md:mb-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: "object-cover object-center rounded",
                                        alt: "hero",
                                        src: "/img/docs/test-run-thresholds.png",
                                        loading: "lazy"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "text-gray-700 pt-6 body-font",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-wrap px-4 md:w-2/3 mx-auto",
                            children: features.map((feature, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_home_FeatureSection_FeatureRow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    title: "",
                                    ...feature
                                }, i))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_home_CtaSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        learnMoreLink: "https://docs.latencylingo.com/docs/getting-started"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ThresholdsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3874,1228,8907,4617,1664,8274,9232,9774,2888,179], function() { return __webpack_exec__(25704); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);